import React, { useEffect, useState } from 'react'
import { buttonVariants } from '../ui/Button';
import IcnEnglishLang from '../svg/IconEnglishLang';
import { merge } from '../../lib/utils';
import IconArabicLang from '../svg/IconArabicLang';
import { useTranslation } from "react-i18next";
import useLanguage from '../../hooks/useLanguage';

const languagesData = [
    { lang: 'English', Icon: <IcnEnglishLang className="w-5 h-5" />, code: 'en' },
    { lang: 'العربية', Icon: <IconArabicLang className="w-5 h-5" />, code: 'ar' },
]

const LanguageSelect = () => {
    const [selected, setSelected] = useState(languagesData[0]);
    const { i18n } = useTranslation();
    const { setLanguage } = useLanguage();

    const targetLanguage = languagesData.find((language) => language.code !== selected.code) || languagesData[1];

    useEffect(() => {
        const storedLanguage = localStorage.getItem('i18nextLng');
        const next = languagesData.find((language) => language.code === storedLanguage)
            || languagesData.find((language) => language.code === i18n.language)
            || languagesData[0];
        setSelected(next);
    }, []);

    useEffect(() => {
        const current = languagesData.find((language) => language.code === i18n.language);
        if (current) setSelected(current);
    }, [i18n.language]);

    useEffect(() => {
        document.body.dir = i18n.dir();
    }, [i18n, i18n.language]);

    const switchLanguage = () => {
        if (!targetLanguage?.code) return;
        localStorage.setItem('i18nextLng', targetLanguage.code);
        setLanguage(targetLanguage.code);
        i18n.changeLanguage(targetLanguage.code);
        setSelected(targetLanguage);
    };

    return (
        <div className="relative w-[140px] min-w-[140px]">
            <button
                type="button"
                onClick={switchLanguage}
                aria-label={`Switch language to ${targetLanguage.lang}`}
                className={merge(buttonVariants({ variant: "outline", size: "sm", className: "w-full justify-between px-4 hover:bg-[unset] before:hidden hover:text-black" }))}
            >
                <div className="flex items-center gap-sm">
                    <span>{targetLanguage.Icon}</span>
                    <span className="block truncate">{targetLanguage.lang}</span>
                </div>
            </button>
        </div>
    );
};

export default LanguageSelect;
